import { useEffect } from 'react';

export function useModalKeyboard(isOpen, { onEscape, onEnter } = {}) {
  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => {
      if (e.key === 'Escape') { onEscape?.(); return; }
      if (e.key === 'Enter' && onEnter) {
        const tag = document.activeElement?.tagName;
        if (tag === 'TEXTAREA') return;
        if (document.activeElement?.contentEditable === 'true') return;
        // The EVENT is forwarded so a caller can reject auto-repeat. A held
        // Enter fires keydown continuously; a multi-step gate that ignores
        // that would arm on the first repeat and commit on a later one
        // without the user ever lifting the key. Existing callers take no
        // argument and are unaffected.
        onEnter(e);
      }
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [isOpen, onEscape, onEnter]);
}
